import SEO from "../components/SEO";
import { seoConfig } from "../config/seo.config";
import HomeHeroSection from "./HomeHeroSection";
import Description from "./Description";
import CustomersSection from "../components/customerSection";
import ChatbotTestimonial from "./Testimonial";
import SalesChatbotFAQ from "./FAQ";
import ChatbotPricing from "./Pricing/ChatbotPricing";
import Demo from "./Demo/demoForm";
interface HomeProps {
  isCalendarOpen: boolean;
  setIsCalendarOpen: (isOpen: boolean) => void;
}
const Home = ({ isCalendarOpen, setIsCalendarOpen }: HomeProps) => {
  return (
    <>
      <SEO {...seoConfig.home} />
      <HomeHeroSection />
      <CustomersSection />
      <Demo isCalendarOpen={isCalendarOpen} setIsCalendarOpen={setIsCalendarOpen}/>
      <Description />
      <ChatbotTestimonial />
      <ChatbotPricing />
      <SalesChatbotFAQ />
    </>
  );
};

export default Home;
